<template>
    <BaseDialog
        :showDialog="!!dialog.show"
        maxDialogWidth="620"
        maxCardHeight="640"
        headline="lang_PUBLISHING_USAGE_ACTION_COMPARE"
        :close="close"
        :alvqa="alvqa"
    >
        <template v-slot:dialogText>
            <v-container fluid v-if="dialog.dataset">
<!-- What is compared -->
                <v-row>
                    <v-col cols="12" :alvqa="alvqa + '-text-schedule'">
                        {{ $t('lang_PUBLISHING_USAGE_CAPTION_COMPARE_DIALOG_TEXT', {
                            schedule: dialog.dataset.description || dialog.dataset.fileName,
                            period: dialog.dataset.period.label
                        }) }}
                    </v-col>
                </v-row>

<!-- What to do with an airing that has no cue sheet -->
                <v-row v-if="dialog.phase === 'confirm'" dense>
                    <v-col cols="12" class="pb-0">
                        <div class="subtitle-2">{{ $t('lang_PUBLISHING_USAGE_CAPTION_COMPARE_NO_SHEET_TITLE') }}</div>
                    </v-col>
                    <v-col cols="12" class="py-0">
                        <v-checkbox
                            :input-value="dialog.noSheet.fromStatement"
                            :label="$t('lang_PUBLISHING_USAGE_CAPTION_COMPARE_NO_SHEET_FROM_STATEMENT')"
                            color="generalCheckbox"
                            hide-details
                            class="mt-1"
                            :alvqa="alvqa + '-checkbox-from-statement'"
                            @change="$store.dispatch('setCompareUsageNoSheet', { fromStatement: !!$event })"
                        />
                    </v-col>
                    <v-col cols="12" class="py-0">
                        <v-checkbox
                            :input-value="dialog.noSheet.airingLevel"
                            :label="$t('lang_PUBLISHING_USAGE_CAPTION_COMPARE_NO_SHEET_AIRING_LEVEL')"
                            color="generalCheckbox"
                            hide-details
                            class="mt-1"
                            :alvqa="alvqa + '-checkbox-airing-level'"
                            @change="$store.dispatch('setCompareUsageNoSheet', { airingLevel: !!$event })"
                        />
                        <div v-if="dialog.noSheet.airingLevel" class="caption subtitleGray--text ml-8" :alvqa="alvqa + '-text-airing-level-hint'">
                            {{ $t('lang_PUBLISHING_USAGE_CAPTION_COMPARE_NO_SHEET_AIRING_LEVEL_HINT') }}
                        </div>
                    </v-col>
                </v-row>

<!-- Running -->
                <v-row v-if="dialog.phase === 'running' || dialog.phase === 'starting'">
                    <v-col cols="12" v-if="dialog.statements && dialog.statements.length">
                        <div class="subtitle-2">{{ $t('lang_PUBLISHING_USAGE_CAPTION_COMPARED_AGAINST') }}</div>
                        <ul :alvqa="alvqa + '-statements'">
                            <li v-for="statement in dialog.statements" :key="statement.id">{{ statement.description || statement.fileName }}</li>
                        </ul>
                    </v-col>
                    <v-col cols="12">
                        <v-progress-linear
                            :value="dialog.percent"
                            :indeterminate="dialog.phase === 'starting'"
                            height="25"
                            color="dialogProgressbar"
                            :alvqa="alvqa + '-progressbar'"
                        >{{ dialog.phase === 'running' ? dialog.percent + ' %' : '' }}</v-progress-linear>
                    </v-col>
                    <v-col cols="12" class="caption subtitleGray--text text-center">
                        {{ $t('lang_PUBLISHING_USAGE_CAPTION_RUNNING_HINT') }}
                    </v-col>
                </v-row>

<!-- Nothing to compare: an explanation, not an error -->
                <v-row v-if="dialog.phase === 'nothing'">
                    <v-col cols="12">
                        <v-alert type="info" dense text class="mb-0" :alvqa="alvqa + '-nothing'">{{ dialog.message }}</v-alert>
                    </v-col>
                </v-row>

<!-- Failed -->
                <v-row v-if="dialog.phase === 'failed'">
                    <v-col cols="12">
                        <v-alert type="error" dense text class="mb-0" :alvqa="alvqa + '-failed'">{{ dialog.message }}</v-alert>
                    </v-col>
                </v-row>

<!-- Done -->
                <v-row v-if="dialog.phase === 'done' && dialog.summary">
                    <v-col cols="12">
                        <v-alert type="success" dense text class="mb-2" :alvqa="alvqa + '-done'">
                            {{ $t('lang_GENERIC_MESSAGE_SUCCESS_PROCESS_COMPLETED') }}
                        </v-alert>
                        <OutcomeCounts :outcomes="dialog.summary.outcomes" :alvqa="alvqa" />
                    </v-col>
                </v-row>
            </v-container>
        </template>

        <template v-slot:dialogActions>
            <v-spacer />
            <template v-if="dialog.phase === 'confirm'">
                <BaseButton label="lang_GENERAL_BUTTON_CANCEL" color="buttonCancel" class="mr-2" :alvqa="alvqa + '-button-cancel'" @click="close" />
                <BaseButton label="lang_PUBLISHING_USAGE_ACTION_COMPARE" icon="compare_arrows" :alvqa="alvqa + '-button-start'" @click="$store.dispatch('startCompareUsage')" />
            </template>
            <BaseButton
                v-if="['running', 'nothing', 'failed'].includes(dialog.phase)"
                label="lang_GENERAL_BUTTON_CLOSE"
                :alvqa="alvqa + '-button-close'"
                @click="close"
            />
            <template v-if="dialog.phase === 'done'">
                <BaseButton label="lang_GENERAL_BUTTON_CLOSE" color="buttonCancel" class="mr-2" :alvqa="alvqa + '-button-close'" @click="close" />
                <BaseButton label="lang_PUBLISHING_USAGE_ACTION_REVIEW" icon="fact_check" :alvqa="alvqa + '-button-review'" @click="openReview" />
            </template>
        </template>
    </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'
import OutcomeCounts from '../_components/OutcomeCounts'

export default {
    name: 'CompareUsageDialog',
    components: { BaseDialog, BaseButton, OutcomeCounts },
    data() {
        return { alvqa: 'publishing-usage-compare-dialog' }
    },
    computed: {
        dialog() { return this.$store.getters.getCompareUsageDialog }
    },
    methods: {
        close() { this.$store.dispatch('closeCompareUsage') },
        openReview() {
            const id = this.dialog.dataset.id
            this.close()
            this.$router.push({ name: 'UsageReview', params: { alvId: id } })
        }
    }
}
</script>
